import { render, staticRenderFns } from "./BatchAddMonitorItem.vue?vue&type=template&id=612fb428&scoped=true"
import script from "./BatchAddMonitorItem.vue?vue&type=script&lang=js"
export * from "./BatchAddMonitorItem.vue?vue&type=script&lang=js"
import style0 from "./BatchAddMonitorItem.vue?vue&type=style&index=0&id=612fb428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612fb428",
  null
  
)

export default component.exports